<app-modal *ngIf="vo$ | async; let vo">
	<div modal-body class="app-delete-report">
		<div *ngIf="vo.totalRequestToDelete !== 0" class="app-delete-report--total-deleted">
			<mat-icon class="success" [svgIcon]="DcIcons.Check"></mat-icon>
			<span i18n="@@delete.report.totalDeleteCount">total-deleted</span>
			<span>: {{vo.totalDeleted}}</span>
		</div>

		<div *ngIf="vo.totalRequestToDelete !== 0" class="app-delete-report--total-not-deleted">
			<mat-icon class="warning" [svgIcon]="DcIcons.Warning"></mat-icon>
			<span i18n="@@delete.report.totalNotDeletedCount">total-not-deleted</span>
			<span>: {{vo.totalNotDeleted}}</span>
		</div>

		<dc-alert [variant]="'flat'" [type]="'error'" [message]="vo.message"></dc-alert>

		<ng-container *ngIf="vo.elementsUnauthorized.length > 0">
			<div (click)="toggleSection('unauthorizedOpened')" class="sub-title">
				<span i18n="@@delete.report.totalElementsUnauthorized">elements-not-auhorized</span>
				<span> ({{vo.elementsUnauthorized.length}})</span>
				<mat-icon *ngIf="!elementsSectionCollapse.unauthorizedOpened" [svgIcon]="DcIcons.Expand"></mat-icon>
				<mat-icon *ngIf="elementsSectionCollapse.unauthorizedOpened" [svgIcon]="DcIcons.Collapse"></mat-icon>
			</div>

			<ng-container *ngIf="elementsSectionCollapse.unauthorizedOpened">
				<ng-container *ngFor="let lib of vo.elementsUnauthorized">
					<p>{{ lib }}</p>
				</ng-container>
			</ng-container>
		</ng-container>

		<ng-container *ngIf="vo.elementsDependenciesReport.size > 0">
			<div (click)="toggleSection('dependenciesOpened')" class="sub-title">
				<span i18n="@@delete.report.totalElementsDependent">elements-used</span>
				<span> ({{vo.elementsDependenciesReport.size}})</span>
				<mat-icon *ngIf="!elementsSectionCollapse.dependenciesOpened" [svgIcon]="DcIcons.Expand"></mat-icon>
				<mat-icon *ngIf="elementsSectionCollapse.dependenciesOpened" [svgIcon]="DcIcons.Collapse"></mat-icon>
			</div>

			<ng-container *ngIf="elementsSectionCollapse.dependenciesOpened">
				<div *ngFor="let entry of vo.elementsDependenciesReport | toArray" class="consumer-elements-container">
					<ng-container *ngIf="vo.elementsDependenciesReport.size === 1">
						<span>{{entry.consumedElementLabel}}</span>
						<div *ngFor="let consumer of entry.consumedWithin" class="consumer-element">
							<a appNavigate [navigateTo]="consumer.elemUrl">{{consumer.label}}</a>
							<span>({{consumer.type}}{{consumer.subType !== 'unknown' ? ': ' + consumer.subType : ''}})</span>
						</div>
					</ng-container>

					<ng-container *ngIf="vo.elementsDependenciesReport.size > 1 && elementsSectionCollapse.dependenciesOpened">
						<div (click)="toggleReportFor(entry.consumedElementLabel)" class="consumer-element-label">
							<span id="element-to-delete">{{entry.consumedElementLabel}}</span>
							<span class="consumer-element-more-less">
						<mat-icon *ngIf="!entry.isOpen">add</mat-icon>
						<mat-icon *ngIf="entry.isOpen">remove</mat-icon>
					</span>
						</div>

						<ng-container *ngIf="entry.isOpen">
							<div *ngFor="let consumer of entry.consumedWithin" class="consumer-element">
								<a appNavigate [navigateTo]="consumer.elemUrl">{{consumer.label}}</a>
								<span>({{consumer.type}}{{consumer.subType !== 'unknown' ? ': ' + consumer.subType : ''}})</span>
							</div>
						</ng-container>
					</ng-container>
				</div>
			</ng-container>
		</ng-container>
	</div>
</app-modal>
